import downArrowIcon from './images/down-arrow.svg'
import blueTopBackground from './images/blue-bg-top-mobile.svg'
import blueBottomBackground from './images/blue-bg-bottom-mobile.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight'
import { useNavigate } from 'react-router-dom'
import { Color, RoutePath } from '../../constants'
import NavBar from '../NavBar'
import { forwardRef } from 'react'
import Button from '../shared/Button'

const IntroMobile = forwardRef((_props, ref) => {
  const navigate = useNavigate()
  return (
    <section
      id="intro-mobile"
      className="bg-black pt-4 pb-16 px-8 overflow-x-hidden"
      ref={ref as any}
    >
      <NavBar />
      <div className="w-full h-full m-auto">
        <div className="flex flex-col justify-center gap-16 items-center mt-64">
          <div className="flex flex-col items-center justify-center text-center">
            <h4 className="text-[46px] font-decimal text-white">
              Mapping The U.S.
            </h4>
            <div className="relative mb-4 -ml-16 min-w-[385px]">
              <img
                src={blueTopBackground}
                alt="blue squiggly top line"
                className="w-full"
              />
              <h4 className="text-[46px] font-decimal text-white font-bold mb-4 absolute -top-[10px] left-[48px]">
                Reparations
              </h4>
            </div>
            <div className="relative -mr-16 min-w-[385px]">
              <img
                src={blueBottomBackground}
                alt="blue squiggly bottom line"
                className="w-full"
              />
              <h4 className="text-[46px] font-decimal text-white font-bold absolute -top-[10px] left-[48px]">
                Movement
              </h4>
            </div>
          </div>
          <Button
            onClick={() => navigate(RoutePath.Map)}
            textColor={Color.White}
            backgroundColor={Color.Black}
          >
            <p className="text-[16px] uppercase flex-1 font-bold">
              Skip to Map View
            </p>
            <FontAwesomeIcon icon={faArrowRight} />
          </Button>
          <p className="font-decimal uppercase text-[18px] text-white">OR</p>
          <div className="flex gap-4 items-center mb-16">
            <img src={downArrowIcon} alt="mouse with instructions to scroll" />
            <p className="text-white text-[14px] font-decimal">
              Scroll to Explore <br />
              More About The <br />
              Mapping Process
            </p>
          </div>
        </div>
      </div>
    </section>
  )
})

export default IntroMobile
